import styled, { keyframes } from "styled-components";

import Refresh from "../icons/sun_on.svg?react";

const spin = keyframes`
 
    0% {
        transform : rotate(0deg);
    }
    100% {
        transform : rotate(360deg);
    }

`;

const StyledRefresh = styled.div<{ $absolutePositioning?: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  position: ${props => props.$absolutePositioning ? "absolute" : "unset"};
  align-items: center;
  background-color: aliceblue;
  svg {
    width: 5rem;
    height: 5rem;
    animation : ${spin} 1s linear infinite reverse;
   
  }
`;

function RefreshSpinner({ $absolutePositioning }: { $absolutePositioning?: boolean }) {
  return (
    <StyledRefresh $absolutePositioning={$absolutePositioning}>
      <Refresh aria-hidden="true" className="refresh" data-testid="refresh-spinner" />
    </StyledRefresh>
  );
}

export default RefreshSpinner;